import { render } from "./ai-grid-virtual.vue?vue&type=template&id=16ec44a3"
import script from "./ai-grid-virtual.vue?vue&type=script&setup=true&lang=js"
export * from "./ai-grid-virtual.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ai-grid-virtual/ai-grid-virtual.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "16ec44a3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('16ec44a3', __exports__)) {
    api.reload('16ec44a3', __exports__)
  }
  
  module.hot.accept("./ai-grid-virtual.vue?vue&type=template&id=16ec44a3", () => {
    api.rerender('16ec44a3', render)
  })

}


export default __exports__